module.exports = __webpack_public_path__ + "li.svg?7f2cb3e761858cd6cd0dad1e9a99c7b4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/li.svg
// module id = 1466
// module chunks = 0